/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'reports': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M15 1C7.268 1 1 7.268 1 15s6.268 14 14 14 14-6.268 14-14S22.732 1 15 1zM0 15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z" _fill="#180000"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M21 20V7h1v13h-1zM8.5 9h11v14h-11V9zm1 1v12h9V10h-9zm1.5 1.5h6V15h-6v-3.5zm1 1V14h4v-1.5h-4zm-.5 3.5h5v1h-5v-1zm5 3h-5v-1h5v1z" _fill="#180000"/><path pid="2" d="M11 7h10v1H11V7z" _fill="#180000"/>'
  }
})
